import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  width: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import styled from "styled-components";
import { Button } from "../components/Button";
export function OpenCheckoutButton(props) {
    return /*#__PURE__*/ _jsx(StyledButton, _object_spread({
        "data-testid": "open-checkout"
    }, props));
}
var StyledButton = styled(Button)(_templateObject());
